// DevHub UI kit — responsive card grid wrapper.
//
// Mirrors the docs/catalog card grid (`devhub-docs-card-grid`: auto-fill columns
// with a 280px min track, 16px gutter) so any collection of EntityCard / hub cards
// lays out identically across the app. Pass `className` to extend/override.
import { ReactNode } from 'react';
import './CardGrid.css';

export interface CardGridProps {
  children: ReactNode;
  className?: string;
}

export const CardGrid = ({ children, className }: CardGridProps) => (
  <section className={`devhub-card-grid${className ? ` ${className}` : ''}`}>
    {children}
  </section>
);
